import { action } from 'satcheljs/lib/legacy';
import FindControlViewState from 'owa-recipient-types/lib/types/FindControlViewState';
import FindRecipientPersonaType from 'owa-recipient-types/lib/types/FindRecipientPersonaType';

export default action('setFindResultSet')(function setFindResultSet(
    viewstate: FindControlViewState,
    findResultSet: FindRecipientPersonaType[]
) {
    viewstate.findResultSet = findResultSet;
});
